import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { SettingsService } from '../../service/common/settings.service';
import { isNullOrUndefined } from 'util';
import { Client, Card, Vehicle } from '../../entity';
import { AuthService, UsersService } from '../../service';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';


@Component({
    selector: 'app-user',
    templateUrl: './user.component.html'
})
export class UserComponent implements OnInit {
    user: Client = new Client();
    settings: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private settingsService: SettingsService,
        private usersService: UsersService


    ) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        let user = new Client();
        user.fromObject(this.route.snapshot.data['user']);

        user.Cards = this.getUserCards(user.PortalOperatorCards);
        user.Vehicles = this.getUserVehicles(user.Vehicles);

        if (user.Avatar === null) {
            user.Avatar = '../../../assets/placeholder.jpg';
        }

        this.user = user;
    }

    getUserVehicles(userVehicles: Array<Vehicle>) {
        let vehicles = new Array<Vehicle>();
        userVehicles.forEach(userVehicle => {
            let vehicle = new Vehicle();
            vehicle.fromObject(userVehicle);

            vehicles.push(vehicle);
        });
        return vehicles;
    }

    getUserCards(userCards: Array<any>) {
        let cards = new Array<Card>();
        userCards.forEach(userCard => {
            let card = new Card();
            card.fromObject(userCard.card);

            card.CardType = this.settingsService.CARD_TYPES(card.CardTypeID);

            cards.push(card);
        });
        return cards;
    }

    seeMoreDetails(route: string) {
        var queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
        queryParams['name'] = `${this.user.FullName}`;
        queryParams['id'] = this.user.PortalOperatorID;

        this.router.navigate([`users/${route}/po`], { queryParams: queryParams });
    }
    deleteUser() {

        this.usersService.deleteUser(this.user.PortalOperatorID).subscribe(data => console.log(data.toString()));
        this.router.navigate([`users`]);

    }
}
